var _style, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVendorOffline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A4ACB0;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    className: "st0",
    cx: 100,
    cy: 100,
    r: 100
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3578",
    className: "st1",
    d: "M161.5,153.8c-3-23.8-20.1-43.4-43.3-49.6c13.1-5.9,21.6-18.9,21.9-33.3 c-1.5-22.1-20.7-38.8-42.8-37.3C77.2,35.1,61.3,51,59.9,71c0.2,14.4,8.8,27.4,21.9,33.3c-23.2,6.1-40.3,25.7-43.3,49.6 c-0.2,2.4,1.6,4.4,4,4.6h114.8c2.3-0.1,4.1-1.9,4.2-4.2C161.5,154.1,161.5,154,161.5,153.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorOffline);
export default __webpack_public_path__ + "static/media/vendor-offline.bc2c6f513b992f017cea040d1cccccdd.svg";
export { ForwardRef as ReactComponent };